import React, { useState, useEffect } from 'react';

function Department() {
  const language = localStorage.getItem("language") || "English";
  const [departments, setDepartments] = useState([]);
  const [showInput, setShowInput] = useState(false);
  const [newDepartment, setNewDepartment] = useState('');
  const [classes, setClasses] = useState([
    { en: 'Class I', mr: 'इयत्ता पहिली' },
    { en: 'Class II', mr: 'इयत्ता दुसरी' },
    { en: 'Class III', mr: 'इयत्ता तिसरी' },
    { en: 'Class IV', mr: 'इयत्ता चौथी' },
    { en: 'Class V', mr: 'इयत्ता पाचवी' },
    { en: 'Class VI', mr: 'इयत्ता सहावी' },
    { en: 'Class VII', mr: 'इयत्ता सातवी' },
    { en: 'Class VIII', mr: 'इयत्ता आठवी' },
    { en: 'Class IX', mr: 'इयत्ता नववी' },
    { en: 'Class X', mr: 'इयत्ता दहावी' },
    { en: 'Class XI', mr: 'इयत्ता अकरावी' },
    { en: 'Class XII', mr: 'इयत्ता बारावी' },
    { en: 'Class Jr KG', mr: 'इयत्ता ज्युनियर के जी' },
    { en: 'Class Sr KG', mr: 'इयत्ता सिनियर के जी' }
  ]);

    // Helper function to get class name based on language
  const getClassName = (classItem) => {
    return language === 'Marathi' ? classItem.mr : classItem.en;
  };

  const [showClassInput, setShowClassInput] = useState(false);
  const [newClass, setNewClass] = useState('');
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [udiseNumber, setUdiseNumber] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editDepartment, setEditDepartment] = useState('');
  const [editedDepartmentName, setEditedDepartmentName] = useState('');
  
const formatClassName = (firebaseClassKey) => {
    if (language === 'Marathi') {
        // Convert English class name to Marathi
        const englishClass = firebaseClassKey.replace(/^Class\s*/i, '').trim();
        const foundClass = classes.find(c => c.en === englishClass);
        return foundClass ? `इयत्ता ${foundClass.mr}` : firebaseClassKey;
    }
    return firebaseClassKey; // Return as is for English
};

const toFirebaseClassKey = (displayName) => {
    if (language === 'Marathi') {
        const marathiClass = displayName.replace(/^इयत्ता\s*/, '').trim();
        const foundClass = classes.find(c => c.mr === marathiClass);
        return foundClass ? `Class ${foundClass.en}` : displayName;
    }
    return `Class ${displayName.replace(/^Class\s*/, '').trim()}`; // Return as is for English
};

const fetchClasses = async () => {
    if (selectedDepartment && udiseNumber) {
        const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/department/${selectedDepartment}.json`;
        try {
            const response = await fetch(firebaseUrl);
            if (!response.ok) {
                throw new Error('Failed to fetch classes');
            }
            const data = await response.json();
            if (data && typeof data === 'object') {
                const trueClasses = Object.keys(data)
                    .filter((key) => data[key] === true)
                    .map((key) => formatClassName(key));
                setSelectedClasses(trueClasses);
            } else {
                setSelectedClasses([]);
            }
        } catch (error) {
            console.error('Error fetching classes:', error);
            alert('Failed to fetch classes: ' + error.message);
        }
    } else {
        setSelectedClasses([]);
    }
};


  const handleDeleteDepartment = async (deptName) => {
    if (!window.confirm(`Are you sure you want to delete the department "${deptName}"?`)) {
      return;
    }

    const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/department/${deptName}.json`;

    try {
      const response = await fetch(firebaseUrl, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Failed to delete department');
      }

      setDepartments(departments.filter((dept) => dept !== deptName));
      if (selectedDepartment === deptName) {
        setSelectedDepartment('');
        setSelectedClasses([]);
      }
      alert(`Department "${deptName}" deleted successfully!`);
    } catch (error) {
      console.error('Error deleting department:', error);
      alert('Failed to delete department: ' + error.message);
    }
  };

  useEffect(() => {
    const storedUdiseNumber = localStorage.getItem("udiseNumber");
    if (storedUdiseNumber) {
      setUdiseNumber(storedUdiseNumber);
    } else {
      alert("UDISE Number is missing!");
      return;
    }

    const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${storedUdiseNumber}/department.json`;
    fetch(firebaseUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch departments');
        }
        return response.json();
      })
     .then((data) => {
        if (data) {
          const departmentNames = Object.keys(data).filter((key) => data[key] && typeof data[key] === 'object');
          setDepartments(departmentNames);

          // Collect all unique classes from all departments
          const allClasses = new Set(classes); // Start with predefined classes
          departmentNames.forEach((dept) => {
            const deptData = data[dept];
            if (deptData && typeof deptData === 'object') {
              Object.keys(deptData)
                .filter((key) => deptData[key] === true)
                .forEach((classKey) => {
                  const formattedClass = classKey.replace(/^Class\s*/i, '').trim();
                  allClasses.add(formattedClass);
                });
            }
          });
          setClasses(Array.from(allClasses).sort()); // Update classes state
          
        } else {
          setDepartments([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching departments:', error);
        alert('Failed to fetch departments: ' + error.message);
      });
  }, []);

useEffect(() => {
    if (selectedDepartment && udiseNumber) {
        const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/department/${selectedDepartment}.json`;
        fetch(firebaseUrl)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch classes');
                }
                return response.json();
            })
            .then((data) => {
                if (data && typeof data === 'object') {
                    const trueClasses = Object.keys(data)
                        .filter((key) => data[key] === true)
                        .map((key) => formatClassName(key));
                    setSelectedClasses(trueClasses);
                } else {
                    setSelectedClasses([]);
                }
            })
            .catch((error) => {
                console.error('Error fetching classes:', error);
                alert('Failed to fetch classes: ' + error.message);
            });
    } else {
        setSelectedClasses([]);
    }
}, [selectedDepartment, udiseNumber]);


 const handleSelectChange = (dept) => {
  setSelectedDepartment(dept);
  setShowInput(dept === 'add');
  setIsDropdownOpen(false);
  setIsEditing(false);
  setEditDepartment('');
  setEditedDepartmentName('');
};;

  const handleAddDepartment = async () => {
  if (!newDepartment.trim()) {
    alert('Please enter a valid department name.');
    return;
  }

  const departmentName = newDepartment.trim();
  const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/department/${departmentName}.json`;

  try {
    if (isEditing) {
      // Fetch existing classes for the department being edited
      const oldDepartmentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/department/${editDepartment}.json`;
      const response = await fetch(oldDepartmentUrl);
      if (!response.ok) {
        throw new Error('Failed to fetch existing department data');
      }
      const existingData = await response.json();

      // Save new department with existing classes
      const newResponse = await fetch(firebaseUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(existingData || {}),
      });

      if (!newResponse.ok) {
        throw new Error('Failed to update department');
      }

      // Delete old department
      await fetch(oldDepartmentUrl, {
        method: 'DELETE',
      });

      setDepartments(departments.map((dept) => (dept === editDepartment ? departmentName : dept)));
      setSelectedDepartment(departmentName);
      alert('Department updated successfully!');
    } else {
      const response = await fetch(firebaseUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error('Failed to add department');
      }

      setDepartments([...departments, departmentName]);
      setSelectedDepartment(departmentName);
      alert('Department added successfully!');
    }

    setNewDepartment('');
    setNewClass('');
    setShowInput(false);
    setIsEditing(false);
    setEditDepartment('');
    setEditedDepartmentName('');
  } catch (error) {
    console.error('Error processing department:', error);
    alert(`Failed to ${isEditing ? 'update' : 'add'} department: ` + error.message);
  }
};

 const handleCloseInput = () => {
  setShowInput(false);
  setNewDepartment('');
  setSelectedDepartment('');
  setIsEditing(false);
  setEditDepartment('');
  setEditedDepartmentName('');
};

  const handleClassChange = (e) => {
    const { value, checked } = e.target;
    setSelectedClasses((prev) =>
      checked ? [...prev, value] : prev.filter((classItem) => classItem !== value)
    );
  };

  
const handleAddClass = async () => {
    if (!newClass.trim()) {
        alert(language === 'Marathi' ? 'कृपया वर्गाचे नाव प्रविष्ट करा' : 'Please enter a valid class name.');
        return;
    }
    
    const formattedClass = newClass.trim();
    const classExists = classes.some(c => 
        language === 'Marathi' ? c.mr === formattedClass : c.en === formattedClass
    );

    if (!classExists) {
        const newClassObj = { 
            en: formattedClass, 
            mr: formattedClass 
        };
        
        // Save to Firebase
        const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/department/${selectedDepartment}.json`;
        const classData = { [formattedClass]: true }; // Save the new class

        try {
            const response = await fetch(firebaseUrl, {
                method: 'PATCH', // Use PATCH to add new class without overwriting existing ones
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(classData),
            });

            if (!response.ok) {
                throw new Error('Failed to save new class to Firebase');
            }

            // Update local state to include the new class
            setClasses(prevClasses => [...prevClasses, newClassObj]);

            // Fetch updated classes from Firebase
            await fetchClasses(); // Call a function to fetch classes from Firebase

            alert('Class added successfully!');
        } catch (error) {
            console.error('Error saving class:', error);
            alert('Error saving class: ' + error.message);
        }
    } else {
        alert(language === 'Marathi' ? 'हा वर्ग आधीच अस्तित्वात आहे' : 'This class already exists');
    }
    
    setNewClass(''); // Clear the input field
    setShowClassInput(false); // Hide the input for adding a new class
};




  const handleCloseClassInput = () => {
    setShowClassInput(false);
    setNewClass('');
  };

const handleSaveToFirebase = async () => {
    if (!selectedDepartment || selectedClasses.length === 0 || !udiseNumber) {
        alert('Please select a department and at least one class.');
        return;
    }

    const firebaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/department/${selectedDepartment}.json`;
    
    // Create class data based on the selected classes
    const classData = selectedClasses.reduce((acc, classItem) => {
        acc[classItem] = true; // Save the class name directly without any prefixes
        return acc;
    }, {});

    try {
        const response = await fetch(firebaseUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(classData),
        });

        if (!response.ok) {
            throw new Error('Failed to save data to Firebase');
        }

        alert('Classes saved successfully!');
        setSelectedDepartment('');
        setSelectedClasses([]);
    } catch (error) {
        console.error('Error saving data:', error);
        alert('Error saving data: ' + error.message);
    }
};







  if (!isVisible) {
    return null;
  }

  const handleEditDepartment = (deptName) => {
  setIsEditing(true);
  setEditDepartment(deptName);
  setEditedDepartmentName(deptName);
  setNewDepartment(deptName);
  setShowInput(true);
  setIsDropdownOpen(false);
};


const renderClasses = () => {
    // Create a unique set of classes to avoid duplicates
    const uniqueClasses = new Set();

    // Add predefined classes
    classes.forEach(classItem => {
        uniqueClasses.add(classItem.en); // Add English name
        uniqueClasses.add(classItem.mr); // Add Marathi name
    });

    // Add selected classes (newly added classes)
    selectedClasses.forEach(className => {
        uniqueClasses.add(className); // Add the class name directly
    });

    // Convert the set back to an array for rendering
    const allClasses = Array.from(uniqueClasses).map(className => {
        return {
            en: className,
            mr: className // Assuming the same name for simplicity; adjust if needed
        };
    });

    return allClasses
        .filter(classItem => classItem && classItem.en && classItem.mr) // Filter out invalid entries
        .map((classItem, index) => {
            const isChecked = selectedClasses.includes(classItem.en) || selectedClasses.includes(classItem.mr);
            return (
                <div key={index} style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px',
                    backgroundColor: '#f7fafc',
                    borderRadius: '6px',
                    border: '1px solid #edf2f7'
                }}>
                    <input
                        type="checkbox"
                        id={`class-${classItem.en}`}
                        value={classItem.en} // Use classItem.en directly without prefix
                        checked={isChecked} // Check against both English and Marathi
                        onChange={handleClassChange}
                        style={{
                            marginRight: '8px',
                            accentColor: '#3182ce',
                            width: '18px',
                            height: '18px'
                        }}
                    />
                    <label
                        htmlFor={`class-${classItem.en}`}
                        style={{
                            fontSize: '16px',
                            color: '#4a5568',
                            cursor: 'pointer'
                        }}
                    >
                        {getClassName(classItem)} 
                    </label>
                </div>
            );
        });
};




  
  return (
    <div className='main-content-of-page' style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f4f7fa',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        padding: '30px',
        width: '100%',
        maxWidth: '500px',
        fontFamily: "'Inter', sans-serif",
        position: 'relative'
      }}>
       
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1a202c',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
         {language === 'English' ?  'Department Management' : 'विभाग व्यवस्थापन' }
        </h2>

      <div style={{
  width: '100%',
  padding: '12px',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  fontSize: '16px',
  color: '#4a5568',
  backgroundColor: '#f7fafc',
  marginBottom: '20px',
  cursor: 'pointer',
  position: 'relative',
  transition: 'border-color 0.2s'
}}
onClick={() => setIsDropdownOpen(!isDropdownOpen)}
onFocus={(e) => e.currentTarget.style.borderColor = '#3182ce'}
onBlur={(e) => e.currentTarget.style.borderColor = '#e2e8f0'}
>
  <div>{selectedDepartment || 'Select Department'}</div>
  {isDropdownOpen && (
    <div style={{
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: '#ffffff',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      maxHeight: '200px',
      overflowY: 'auto',
      zIndex: 10,
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
    }}>
      {departments.map((dept, index) => (
        <div
          key={index}
          style={{
            padding: '10px 15px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f7fafc'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
        >
          <span
            style={{
              flex: 1,
              fontSize: '16px',
              color: '#4a5568'
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleSelectChange(dept);
            }}
          >
            {dept}
          </span>
          <div style={{ display: 'flex', gap: '10px' }}>
            <i
              className="fa-solid fa-pencil"
              style={{
                color: '#3182ce',
                fontSize: '18px',
                cursor: 'pointer',
                padding: '2px',
                borderRadius: '4px',
                transition: 'background-color 0.2s'
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleEditDepartment(dept);
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e6f0fa'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              title={`Edit ${dept}`}
              role="button"
              aria-label={`Edit department ${dept}`}
            ></i>
            <i
              className="fa-solid fa-trash"
              style={{
                color: 'red',
                fontSize: '18px',
                cursor: 'pointer',
                padding: '2px',
                borderRadius: '4px',
                transition: 'background-color 0.2s'
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteDepartment(dept);
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fee2e2'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              title={`Delete ${dept}`}
              role="button"
              aria-label={`Delete department ${dept}`}
            ></i>
          </div>
        </div>
      ))}
      <div
        style={{
          padding: '10px 15px',
          cursor: 'pointer',
          transition: 'background-color 0.2s',
          borderTop: '1px solid #e2e8f0'
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleSelectChange('add');
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f7fafc'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
      >
        Add New Department
      </div>
    </div>
  )}
</div>

{showInput && (
  <div style={{
    display: 'flex',
    gap: '10px',
    marginBottom: '20px'
  }}>
    <input
      type="text"
      value={newDepartment}
      onChange={(e) => setNewDepartment(e.target.value)}
      placeholder={isEditing ? "Edit department name" : "Enter new department"}
      style={{
        flex: '1',
        padding: '12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '16px',
        color: '#4a5568',
        outline: 'none',
        transition: 'border-color 0.2s'
      }}
      onFocus={(e) => e.target.style.borderColor = '#3182ce'}
      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
    />
    <button
      onClick={handleAddDepartment}
      style={{
        padding: '12px 20px',
        backgroundColor: '#3182ce',
        color: '#ffffff',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '500',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
      }}
      onMouseOver={(e) => e.target.style.backgroundColor = '#2b6cb0'}
      onMouseOut={(e) => e.target.style.backgroundColor = '#3182ce'}
    >
      {isEditing ? 'Update' : 'Add'}
    </button>
    <button
      onClick={handleCloseInput}
      style={{
        padding: '12px 20px',
        backgroundColor: '#e53e3e',
        color: '#ffffff',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '500',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.2s'
      }}
      onMouseOver={(e) => e.target.style.backgroundColor = '#c53030'}
      onMouseOut={(e) => e.target.style.backgroundColor = '#e53e3e'}
    >
      Close
    </button>
  </div>
)}

<div style={{ marginBottom: '20px' }}>
          <h2 style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#1a202c',
            marginBottom: '15px'
          }}>
            {language === 'English' ? 'Classes' : 'वर्ग'}
          </h2>
            <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
            gap: '10px',
            marginBottom: '15px'
          }}>
            {renderClasses()}
          </div>

          <button
            onClick={() => setShowClassInput(true)}
            style={{
              padding: '10px 20px',
              backgroundColor: '#3182ce',
              color: '#ffffff',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              border: 'none',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#2b6cb0'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#3182ce'}
          >
            {language === 'English' ?  'Add New Class' : 'नवीन वर्ग जोडा' }
          </button>

          {showClassInput && (
            <div style={{
              display: 'flex',
              gap: '10px',
              marginTop: '15px'
            }}>
              <input
                type="text"
                value={newClass}
                onChange={(e) => setNewClass(e.target.value)}
               placeholder={language === 'English' ? 'Enter new class (e.g., Pre-K)' : 'नवीन वर्ग प्रविष्ट करा (उदा. प्री-के)' }
                style={{
                  flex: '1',
                  padding: '12px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '16px',
                  color: '#4a5568',
                  outline: 'none',
                  transition: 'border-color 0.2s'
                }}
                onFocus={(e) => e.target.style.borderColor = '#3182ce'}
                onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
              />
              <button
                onClick={handleAddClass}
                style={{
                  padding: '12px 20px',
                  backgroundColor: '#3182ce',
                  color: '#ffffff',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '500',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#2b6cb0'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#3182ce'}
              >
                Add
              </button>
              <button
                onClick={handleCloseClassInput}
                style={{
                  padding: '12px 20px',
                  backgroundColor: '#e53e3e',
                  color: '#ffffff',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '500',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#c53030'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#e53e3e'}
              >
                Close
              </button>
            </div>
          )}
        </div>

        <button
          onClick={handleSaveToFirebase}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#2f855a',
            color: '#ffffff',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '500',
            border: 'none',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#276749'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#2f855a'}
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default Department;